<template>
  <div class="row">
    <div class="col-12">
      <card>
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="filter">
            <filter-component
              @filter="handleFilter"
              @showHideLoading="showHideLoading"
              :filterOfLots="false"
              :isRequiredFarms="true"
              classFarms="`col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4`"
            >
              <template slot="after-lot">
                <select-component
                  class="pt-3"
                  :rowClass="`col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3`"
                  :labelSelect="`${$t('common_words.type')}: *`"
                  :requireClass="`required-reportType`"
                  :dataOptions="reportTypes"
                  :initialSelection="dataFilter.reportType"
                  :isMultiple="false"
                  @onChange="handleChangeSelected"
                  modelName="reportType"
                />
              </template>
            </filter-component>
          </el-collapse-item>
        </el-collapse>
      </card>
      <div v-if="isIndex()">
        <card
          class="custom-shadow-card-header"
          :title="$t('production.harvested_kilograms')"
          v-if="this.tableData && this.tableData.length > 0"
        >
          <el-container>
            <aside-list
              addClass=".el-menu-harvest"
              @clickItem="handleChangeAsideHarvest"
              :label="$t('common_words.farms')"
              :list="asideListHarvest"
              v-if="this.dataFilter.reportType == 'detallado'"
            />
            <el-container>
              <el-main :style="'paddingLeft: 0 !important; overflow: hidden;'">
                <card-header :propPagination="pagination" class="mr-3 mt-4" />
                <master-table
                  :infoTable="queriedData"
                  :columns="tableColumns"
                />
                <card-footer :propPagination="pagination" ref="cardfooter" />
                <export-tables
                  :pdf="{
                    filename:
                      dataFilter.reportType === 'consolidado'
                        ? `${$t(
                            'production.consolidated_fruit_harvest_report'
                          )}.pdf`
                        : `${$t(
                            'production.detailed_fruit_harvest_report'
                          )} - ${farmHarvestSelected}.pdf`,
                    route:
                      dataFilter.reportType === 'consolidado'
                        ? 'cutting/fruitsreports/consolidated/pdf'
                        : 'cutting/fruitsreports/detailed/pdf',
                    paramMethod: 'POST',
                    plusData: { ...exportHarvestData },
                  }"
                  :xls="{
                    filename:
                      dataFilter.reportType === 'consolidado'
                        ? `${$t(
                            'production.consolidated_fruit_harvest_report'
                          )}.xlsx`
                        : `${$t(
                            'production.detailed_fruit_harvest_report'
                          )} - ${farmHarvestSelected}.xlsx`,
                    route:
                      dataFilter.reportType === 'consolidado'
                        ? 'cutting/fruitsreports/consolidated/excel'
                        : 'cutting/fruitsreports/detailed/excel',
                    paramMethod: 'POST',
                    plusData: { ...exportHarvestData },
                  }"
                />
              </el-main>
            </el-container>
          </el-container>
        </card>
        <card
          class="custom-shadow-card-header"
          :title="$t('production.rejected_kilograms')"
          v-if="this.tableData2 && this.tableData2.length > 0"
        >
          <el-container>
            <aside-list
              addClass=".el-menu-rejected"
              @clickItem="handleChangeAsideRejected"
              :label="$t('common_words.farms')"
              :list="asideListRejected"
              v-if="this.dataFilter.reportType == 'detallado'"
            />
            <el-container>
              <el-main :style="'paddingLeft: 0 !important; overflow: hidden;'">
                <card-header :propPagination="pagination2" class="mr-3 mt-4" />
                <master-table
                  :infoTable="queriedData2"
                  :columns="tableColumns2"
                />
                <card-footer :propPagination="pagination2" ref="cardfooter" />
                <export-tables
                  :pdf="{
                    filename:
                      dataFilter.reportType === 'consolidado'
                        ? `${$t(
                            'production.consolidated_fruit_rejection_report'
                          )}.pdf`
                        : `${$t(
                            'production.detailed_fruit_rejection_report'
                          )} - ${farmRejectionSelected}.pdf`,
                    route:
                      dataFilter.reportType === 'consolidado'
                        ? 'cutting/fruitsreports/consolidated/pdf'
                        : 'cutting/fruitsreports/detailed/pdf',
                    paramMethod: 'POST',
                    plusData: { ...exportRejectionsData },
                  }"
                  :xls="{
                    filename:
                      dataFilter.reportType === 'consolidado'
                        ? `${$t(
                            'production.consolidated_fruit_rejection_report'
                          )}.xlsx`
                        : `${$t(
                            'production.detailed_fruit_rejection_report'
                          )} - ${farmRejectionSelected}.xlsx`,
                    route:
                      dataFilter.reportType === 'consolidado'
                        ? 'cutting/fruitsreports/consolidated/excel'
                        : 'cutting/fruitsreports/detailed/excel',
                    paramMethod: 'POST',
                    plusData: { ...exportRejectionsData },
                  }"
                />
              </el-main>
            </el-container>
          </el-container>
        </card>
      </div>
      <not-index-permissions v-else />
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util.js';
import {
  configConsolidatedHarvestTable,
  configConsolidatedRejectedTable,
} from './fruitsConsolidatedReportTable';
import {
  configDetailedHarvestTable,
  configDetailedRejectedTable,
} from './fruitsDetailedReportTable';
import paginationDataFruits from './paginationDataFruits';
import AsideList from 'src/components/Layouts/AsideList.vue';
import Filter from 'src/components/Filter/Filters.vue';
import i18n from 'src/i18n';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import SweetAlert from 'src/class/Alerts';

export default {
  components: {
    [Filter.name]: Filter,
    [AsideList.name]: AsideList,
  },

  computed: {
    ...paginationDataFruits.functions,
    exportHarvestData() {
      return {
        data: { ...this.tableData },
        type: 'harvest',
        farmSelected: this.farmHarvestSelected,
      };
    },
    exportRejectionsData() {
      return {
        data: { ...this.tableData2 },
        type: 'rejection',
        farmSelected: this.farmRejectionSelected,
      };
    },
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
    reportTypes() {
      return [
        { id: 'detallado', name: i18n.t('common_words.detailed') },
        { id: 'consolidado', name: i18n.t('common_words.consolidated') },
      ];
    },
    asideListHarvest() {
      if (this.dataHarvest) {
        return Object.keys(this.dataHarvest).map((key, index) => {
          return {
            id: index,
            name: key,
          };
        });
      }
    },
    asideListRejected() {
      if (this.dataRejected) {
        return Object.keys(this.dataRejected).map((key, index) => {
          return {
            id: index,
            name: key,
          };
        });
      }
    },
  },

  data() {
    return {
      pagination: paginationDataFruits.pagination,
      pagination2: paginationDataFruits.pagination2,
      tableData: [],
      tableData2: [],
      tableColumns: [],
      tableColumns2: [],
      searchQuery: '',
      searchQuery2: '',
      dataHarvest: null,
      dataRejected: null,
      harvestIndexSelected: null,
      rejectionIndexSelected: null,
      farmHarvestSelected: null,
      farmRejectionSelected: null,
      valueCollapse: null,
      activeName: 'filter',
      dataFilter: {
        reportType: 'consolidado',
      },
    };
  },

  mixins: [MixinMasters, MixinPermissions, MixinMenu, MixinForm],

  watch: {
    '$i18n.locale': 'setupTable',
  },

  methods: {
    handleChangeAsideHarvest(data) {
      if (this.harvestIndexSelected != data.index) {
        this.harvestIndexSelected = data.index;
        this.farmHarvestSelected = Object.keys(this.dataHarvest)[data.index];
        this.tableData = this.dataHarvest[this.farmHarvestSelected];
        let columns = {
          harvest:
            this.tableData && this.tableData[0] && this.tableData[0].harvest
              ? Object.keys(this.tableData[0].harvest)
              : null,
          rejected:
            this.tableData2 && this.tableData2[0] && this.tableData2[0].rejected
              ? Object.keys(this.tableData2[0].rejected)
              : null,
        };
        this.setupTable(columns);
      }
    },

    handleChangeAsideRejected(data) {
      if (this.rejectionIndexSelected != data.index) {
        this.rejectionIndexSelected = data.index;
        this.farmRejectionSelected = Object.keys(this.dataRejected)[data.index];
        this.tableData2 = this.dataRejected[this.farmRejectionSelected];
        let columns = {
          harvest:
            this.tableData && this.tableData[0] && this.tableData[0].harvest
              ? Object.keys(this.tableData[0].harvest)
              : null,
          rejected:
            this.tableData2 && this.tableData2[0] && this.tableData2[0].rejected
              ? Object.keys(this.tableData2[0].rejected)
              : null,
        };
        this.setupTable(columns);
      }
    },

    handleChangeSelected(data) {
      this.$set(this.dataFilter, data.name, data.selects);
      this.tableData = [];
      this.tableData2 = [];
    },

    handleCollapse(val) {
      this.valueCollapse = val;
    },

    handleFilter(data) {
      this.dataFilter = {
        ...this.dataFilter,
        datef: data.datef,
        datei: data.datei,
        bySel: data.bySel,
        farm: data.farm,
      };

      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (!isset(this.dataFilter.reportType)) {
            return this.validationInputsRequired('reportType');
          } else {
            this.getData();
          }
        }
      });
    },

    getData() {
      this.showHideLoading(true);
      this.tableData = [];
      let data = { ...this.dataFilter, route: 'cutting/fruitsreports' };

      if (data.bySel === 'Año') {
        data.datei += '-01-01';
        data.datef += '-12-31';
      }

      Axios.postMasters(data)
        .then((response) => {
          if (!isset(response.data.data.harvest)) {
            SweetAlert.warning(i18n.t('common_words.unavailable_data'));
          } else {
            if (this.dataFilter.reportType == 'consolidado') {
              this.tableData = response.data.data.harvest;
              this.tableData2 = response.data.data.rejected;

              let columns = {
                harvest:
                  this.tableData &&
                  this.tableData[0] &&
                  this.tableData[0].harvest
                    ? Object.keys(this.tableData[0].harvest)
                    : null,
                rejected:
                  this.tableData2 &&
                  this.tableData2[0] &&
                  this.tableData2[0].rejected
                    ? Object.keys(this.tableData2[0].rejected)
                    : null,
              };

              this.setupTable(columns);
            } else {
              this.dataHarvest = response.data.data.harvest;
              this.dataRejected = response.data.data.rejected;

              this.farmHarvestSelected = Object.keys(this.dataHarvest)[0];
              this.farmRejectionSelected = Object.keys(this.dataRejected)[0];

              this.harvestIndexSelected = 0;
              this.rejectionIndexSelected = 0;

              this.tableData = this.dataHarvest[this.farmHarvestSelected];
              this.tableData2 = this.dataRejected[this.farmRejectionSelected];

              let columns = {
                harvest:
                  this.tableData &&
                  this.tableData[0] &&
                  this.tableData[0].harvest
                    ? Object.keys(this.tableData[0].harvest)
                    : null,
                rejected:
                  this.tableData2 &&
                  this.tableData2[0] &&
                  this.tableData2[0].rejected
                    ? Object.keys(this.tableData2[0].rejected)
                    : null,
              };

              this.setupTable(columns);

              setTimeout(() => {
                const aside = document.getElementsByClassName(
                  'custom-el-menu-item-cal .el-menu-harvest'
                )[0];
                aside.click();
              }, 0.1);
              setTimeout(() => {
                const aside = document.getElementsByClassName(
                  'custom-el-menu-item-cal .el-menu-rejected'
                )[0];
                aside.click();
              }, 0.1);
            }
          }

          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    setupTable(data = null) {
      if (this.dataFilter.reportType == 'consolidado') {
        const { harvestTable } = configConsolidatedHarvestTable(data);
        this.tableColumns = harvestTable.tableColumns;
        this.pagination = { ...harvestTable.pagination };
        this.pagination.perPage = 5;
        this.pagination.currentPage = 1;

        const { rejectedTable } = configConsolidatedRejectedTable(data);
        this.tableColumns2 = rejectedTable.tableColumns;
        this.pagination2 = { ...rejectedTable.pagination };
        this.pagination2.perPage = 5;
        this.pagination2.currentPage = 1;
      } else {
        const { harvestTable } = configDetailedHarvestTable(data);
        this.tableColumns = harvestTable.tableColumns;
        this.pagination = { ...harvestTable.pagination };
        this.pagination.perPage = 5;
        this.pagination.currentPage = 1;

        const { rejectedTable } = configDetailedRejectedTable(data);
        this.tableColumns2 = rejectedTable.tableColumns;
        this.pagination2 = { ...rejectedTable.pagination };
        this.pagination2.perPage = 5;
        this.pagination2.currentPage = 1;
      }
    },
  },

  created() {
    this.setupTable();
  },

  mounted() {
    this.selectedItemOnMenu('cutting');
  },

  destroyed() {
    this.deselectedItemOnMenu('cutting');
  },
};
</script>
